import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { EncabezadoPagina } from '@xiltrion/ui/bloques/encabezado-pagina';
import { EstadoVacio } from '@xiltrion/ui/bloques/estados';
import { Button } from '@xiltrion/ui/button';
import { Icono } from '@xiltrion/ui/icono';
import { Item, ItemContent, ItemDescription, ItemTitle } from '@xiltrion/ui/item';
import { cn } from '@xiltrion/ui/utils';
import { apiGet, apiPost } from '@/api/client';
import type { NotificationRow } from '@/api/types';

export function NotificationsPage() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { data = [] } = useQuery({ queryKey: ['notifications', 'all'], queryFn: () => apiGet<NotificationRow[]>('/notifications') });
  const read = (ids: string[] | 'all') => void apiPost('/notifications/read', { ids }).then(() => qc.invalidateQueries({ queryKey: ['notifications'] }));
  return (
    <div className="space-y-6 p-6">
      <EncabezadoPagina titulo="Avisos" acciones={<Button variant="outline" onClick={() => read('all')}>Marcar todo como leído</Button>} />
      {data.length === 0 ? <EstadoVacio titulo="No tienes avisos" borde /> : data.map((n) => (
        <Item key={n.id} variant="outline" asChild className={cn(!n.readAt && 'border-primary/40 bg-primary/5')}>
          <button type="button" className="w-full text-left" onClick={() => { if (!n.readAt) read([n.id]); if (n.link) navigate(n.link); }}>
            <Icono nombre="mdi:bell-outline" className="text-muted-foreground" />
            <ItemContent><ItemTitle>{n.title}</ItemTitle><ItemDescription>{n.body ? `${n.body} · ` : ''}{new Date(n.createdAt).toLocaleString('es-CO')}</ItemDescription></ItemContent>
          </button>
        </Item>
      ))}
    </div>
  );
}
